import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "interval", "max", "min"];
import * as React from 'react';
import cn from 'classnames';
import { isString } from 'lodash';
import { ControlAppearanceType, controlClasses, ControlShapeType, Intent, intentClass, safeInvoke } from '../../../../library';
import { Input } from '../../text-input';
import { IconCaretDown, IconCaretUp } from '../../../../icons';
import { Control, Controls } from '../../control';
export var NumberInput = function NumberInput(props) {
  var className = props.className,
    _props$interval = props.interval,
    interval = _props$interval === void 0 ? 1 : _props$interval,
    max = props.max,
    min = props.min,
    inputProps = _objectWithoutProperties(props, _excluded);
  var shape = props.shape,
    intent = props.intent,
    appearance = props.appearance,
    size = props.size,
    density = props.density;
  var numValue = isString(props.value) ? parseFloat(props.value) : props.value;
  var classNames = cn('number-input', className);
  var arrowClasses = cn('input', 'input-arrows', controlClasses({
    shape: shape,
    size: size,
    density: density,
    appearance: appearance
  }), intentClass(intent), {
    '-disabled': props.isDisabled || inputProps.readOnly
  });
  function add(e) {
    if (props.isDisabled || props.readOnly) return;
    var newValue = numValue ? numValue + interval : interval;
    safeInvoke(props.onUpdate, props.field, newValue);
  }
  function subtract() {
    if (props.isDisabled || props.readOnly) return;
    var newValue = numValue ? numValue - interval : -interval;
    safeInvoke(props.onUpdate, props.field, newValue);
  }
  return React.createElement(Controls, {
    isCombined: true,
    className: classNames
  }, React.createElement(Control, null, React.createElement(Input, _extends({
    type: "number"
  }, inputProps))), React.createElement(Control, {
    span: "shrink"
  }, React.createElement("div", {
    className: arrowClasses
  }, React.createElement("div", {
    onClick: add
  }, React.createElement(IconCaretUp, {
    size: 12
  })), React.createElement("div", {
    onClick: subtract
  }, React.createElement(IconCaretDown, {
    size: 12
  })))));
};
NumberInput.displayName = 'NumberInput';
NumberInput.defaultProps = {
  shape: ControlShapeType.ROUNDED,
  appearance: ControlAppearanceType.OUTLINE,
  intent: Intent.NONE,
  interval: 1
};